<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
  <div>/</div>
  <div>Facilis Origin AIXM 5.1</div>
  <div>/</div>
  <div>Feature: {{ matchingFeature?._name }}</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3>Feature: {{ matchingFeature?._name }}</h3>
  </span>
    <span class="toolbar-icon" >
    <mat-icon color="warn" style="cursor: pointer; "(click)="openLockDialog()" >lock</mat-icon>
    <img class="status-icon" src="assets/icons/list-status.svg" [routerLink]="['/data-catalogue/business-rules']" alt="status icon">
    <mat-icon color="primary" style="cursor: pointer" (click)="save()">
      save
    </mat-icon>
  </span>
</mat-toolbar>
<mat-expansion-panel class="custom-panel">
  <!-- [expanded]="metadataExpanded"
    (opened)="metadataExpanded = true"
    (closed)="metadataExpanded = false" -->
  <mat-expansion-panel-header>
    <mat-panel-title><b>Metadata</b> </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="metadata-content">
    <div class="metadata-item">
      <div class="metadata-key">Identifier:</div>
      <div class="metadata-value">{{ matchingFeature?._name }}</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Catalogue item type:</div>
      <div class="metadata-value">Feature</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Top level feature:</div>
      <div class="metadata-value">YES</div>
    </div>

<div class="metadata-item">
  <div class="metadata-key"><b>Display name:</b></div>
  <!-- <div class="metadata-value">
    <input
      type="text"
      placeholder=""
      [(ngModel)]="matchingFeature.displayName"
      class="transparent-input"
    />
  </div> -->
</div>

<div class="metadata-detailed-item">
  <div class="metadata-detail-key">English</div>
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        placeholder=""
        [(ngModel)]="matchingFeature.displayName"
      />
    </mat-form-field>
  <!-- <div class="metadata-detail-value">{{ matchingFeature?._name }}</div> -->
</div>


    <!-- <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
       <div class="metadata-detail-value">
    <input
      type="text"
      placeholder=""
      [(ngModel)]="matchingFeature.displayName"
      class="transparent-input"
    />
  </div>
      <div class="metadata-detail-value">{{ matchingFeature?._name }}</div>
    </div> -->

    <div class="metadata-item">
      <div class="metadata-key"><b>Description:</b></div>
      </div>
      <!-- <div class="metadata-value full-width-input">
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            matInput
            placeholder=""
            [(ngModel)]="matchingFeature.description"
            name="description"
            rows="4"
          ></textarea>
        </mat-form-field>
      </div> -->
          <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
         <div class="metadata-deatil-value full-width-input">
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            matInput
            placeholder=""
            [(ngModel)]="matchingFeature.description"
            name="description"
            rows="4"
          ></textarea>
        </mat-form-field>
      </div>
      <!-- <div class="metadata-detail-value">{{ matchingFeature?._name }}</div> -->

    </div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited by:</div>
      <div class="metadata-value">john.doe</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited on:</div>
      <div class="metadata-value">1 Feb 2025</div>
    </div>
  </div>
</mat-expansion-panel>

<!-- <div class="metadata-container" [ngClass]="{'expanded': metadataExpanded, 'collapsed': !metadataExpanded}">
  <div class="metadata-container-header">
    <h4>Metadata</h4>
    <div *ngIf="!metadataExpanded" class="expand-button" (click)="toggleMetadata()">▼</div>
    <div *ngIf="metadataExpanded" class="expand-button" (click)="toggleMetadata()">▲</div>
  </div>
  <div class="metadata-content">
    <div class="metadata-item">
      <div class="metadata-key">Identifier:</div>
      <div class="metadata-value">{{ matchingFeature?._name }}</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Catalogue item type:</div>
      <div class="metadata-value">Feature</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Top level feature:</div>
      <div class="metadata-value">YES</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key"><b>Display name:</b></div>
      <div class="metadata-value"></div>
    </div>
    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
      <div class="metadata-detail-value">{{ matchingFeature?._name }}</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key"><b>Description:</b></div>
      <div class="metadata-value"></div>
    </div>
    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
      <div class="metadata-detail-value">description</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited by:</div>
      <div class="metadata-value">john.doe</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited on:</div>
      <div class="metadata-value">1 Feb 2025</div>
    </div>
  </div>
</div> -->

<div class="content-container">
  <div class="tree-container">
    <mat-tree
      #tree
      [dataSource]="treeData"
      [childrenAccessor]="childrenAccessor"
    >
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <span [innerHTML]="node.name"></span>
      </mat-tree-node>

      <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        matTreeNodeToggle
      >
        <button
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + node.name"
        >
          <mat-icon>
            {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
          </mat-icon>
        </button>
        <span [innerHTML]="node.name"></span>
      </mat-tree-node>
    </mat-tree>
  </div>
  <div class="feature-info-container">
    <div class="info-title">
      <div class="official-data">Official Data</div>
      <div class="smaller">(effective 1 FEB 2025)</div>
    </div>
    <div class="occuriencies">Occurencies: 86</div>
  </div>
</div>
